const fields = lang => {
  const isDeLang = lang === 'de-ch'
  const isItLang = lang === 'it-ch'
  return {
    fields: [
      {
        type: 'select',
        width: 'Third',
        label: isDeLang ? 'Anrede' : isItLang ? 'Prefisso' : 'Prefix',
        name: 'salutation',
        required: false,
        maxLength: 30,
        placeholder: isDeLang ? 'Bitte wählen' : isItLang ? 'Si prega di scegliere' : 'Please Select',
        options: [
          {
            label: isItLang ? 'Sig.ra' : 'Ms',
            value: 'Ms',
          },
          {
            label: isItLang ? 'Sig' : 'Mr',
            value: 'Mr',
          },
        ],
      },
      {
        type: 'text',
        width: 'Third',
        label: isDeLang ? 'Vorname' : isItLang ? 'Nome' : 'First Name',
        name: 'first_name',
        required: true,
        maxLength: 30,
        autocompleteAttribute: 'family-name',
        validation: 'Alphabetic',
        pattern: '[a-zA-Z- ]+',
      },
      {
        type: 'text',
        width: 'Third',
        label: isDeLang ? 'Nachname' : isItLang ? 'Cognome' : 'Last Name',
        name: 'last_name',
        required: true,
        maxLength: 30,
        autocompleteAttribute: 'family-name',
        validation: 'Alphabetic',
        pattern: '[a-zA-Z- ]+',
      },
      {
        type: 'email',
        width: 'Half',
        label: isDeLang ? 'E-Mail' : 'Email',
        required: true,
        maxLength: 60,
        autocompleteAttribute: 'email',
        name: 'email',
        pattern: '[^@]+@[^@]+\\.[a-zA-Z]{2,6}',
        title: 'Please match the requested format: Abc123!@berlitz.com',
        placeholder: 'Email',
      },
      {
        type: 'tel',
        width: 'Half',
        label: isDeLang ? 'Telefon' : isItLang ? 'Telefono' : 'Phone',
        required: true,
        maxLength: 20,
        placeholder: '+41 00 000 00 00',
        autocompleteAttribute: 'tel',
        name: 'phone',
        validation: 'Numeric',
        pattern: '\\+?[0-9]+',
        minLength: 6,
        maxLength: 15,
      },
      {
        type: 'text',
        width: 'Half',
        label: isDeLang ? 'PLZ' : isItLang ? 'Codice postale' : 'Zip code',
        required: true,
        maxLength: 20,
        autocompleteAttribute: 'postal-code',
        name: 'zip',
        validation: 'text',
      },
      {
        type: 'select',
        width: 'Half',
        label: isDeLang
          ? 'Wofür interessieren Sie sich?'
          : isItLang ? 'Corso?' : 'Which format are you interested in?',
        name: 'Class_Type__c',
        required: false,
        placeholder: isDeLang ? 'Bitte wählen' : isItLang ? 'Si prega di scegliere' : 'Please Select',
        options: [
          {
            label: isDeLang ? 'Face-to-Face-Sprachtraining' : isItLang ? 'Corso di lingua - di persona' : 'Face-to-Face Language Training',
            value: 'F2F Adult',
          },
          {
            label: isDeLang ? 'Online-Sprachtraining' : isItLang ? 'Corso di lingua - Online' : 'Online Language Training',
            value: 'Online',
          },
          {
            label: isDeLang ? 'Sprachprogramme für Kinder und Teenager' : isItLang ? 'Programmi per bambini e ragazzi' : 'Kids & Teens Language Programs',
            value: 'Kids',
          },
          {
            label: isDeLang ? 'Business-Sprachtraining' : isItLang ? 'Seminari business' : 'Business Language Training',
            value: 'Corporate',
          },
          {
            label: isDeLang ? 'Spracheinschätzung und Tests' : isItLang ? 'Valutazione e test linguistici' : 'Language Assessment and Testing',
            value: 'Testing and Assessment',
          },
        ],
      },
      {
        type: 'textarea',
        width: 'Full',
        label: isDeLang ? 'Ihre Nachricht:' : isItLang ? 'Lascia un messaggio' : 'Message',
        required: false,
        maxLength: 20,
        autocompleteAttribute: 'tel',
        name: 'description',
      },
      {
        width: 'Full',
        label: isDeLang
          ? 'Ich möchte den Newsletter der Berlitz Lugano / Goodlang SA bestellen. Meine Einwilligung kann ich jederzeit per E-Mail an info@berlitzlugano.ch oder durch die Nutzung des Abmeldelinks im Newsletter widerrufen.'
          : isItLang ? 'Desidero ricevere ulteriori informazioni e offerte speciali da Berlitz via e-mail. Berlitz Lugano garantisce che tutti i dati personali saranno trattati in modo confidenziale (in conformità con i requisiti di protezione dei dati) e che nessun dato sarà divulgato a terzi. Posso revocare il mio consenso in qualsiasi momento inviando una mail a info@berlitzlugano.ch.'
            : 'I would like to subscribe to the newsletter of Berlitz Lugano / Goodlang SA. I can withdraw my consent at any time by sending an email to info@berlitzlugano.ch or by using the unsubscribe link provided in the newsletter.',
        hiddenLabel: true,
        name: 'Email_Opt_In__c',
        type: 'checkbox',
        required: false,
        value: '0',
        checkedValue: '1',
        uncheckedValue: '0',
      },
    ],
    fieldsHidden: [
      { name: 'B2C_Lead__c', value: '1' },
      { name: 'form_type', value: 'Form Type b2c' },
      { name: 'form_name', value: 'Main Lead Form B2C' },
      { name: 'Region__c', value: 'EMEA' },
      { name: 'Country_Segmentation__c', value: 'Switzerland' },
      { name: 'country', value: 'Switzerland' },
      { name: 'recordType', value: '0121t000000dYn4' },
      { name: 'Minisites__c', value: 'Lugano' },
      { name: 'lead_source', value: 'Website' },
      { name: 'oid', value: '00D0b000000uiVk' },
    ],
  }
}

export { fields }
